module.exports = __webpack_public_path__ + "static/media/memories_14.b3870da1.jpg";